<template>
	<section>
		<div style="width: 100%">
			<div class="columns is-multiline is-mobile mt-3 is-variable is-2">
				<div
					v-if="shouldQuantityPickerBeShown"
					class="column is-narrow w40-mobile">
					<div class="mr-2 is-inline-block">
						<div
							class="field has-addons has-addons-centered"
							style="border: solid #ccc 1px; border-radius: 5px">
							<p
								class="control"
								style="border-right: solid #ccc 1px">
								<a
									@click="decrementQuantity"
									class="button is-medium is-white h2_5-mobile"
									:class="{
										'px-3': !this.isMobile,
										'px-3': this.isMobile,
									}"
									style="color: #777"
									><i class="fas fas fa-minus"></i>
								</a>
							</p>
							<p class="control">
								<input
									@change="updateQuantity"
									v-model="$data.quantity"
									min="1"
									value="1"
									:max="selectedInventoryItemQuantity"
									class="input is-medium quantity-input has-text-centered px-0-mobile h2_5-mobile"
									type="number"
									placeholder="##"
									style="
										max-width: 1in;
										border-top: none;
										border-bottom: none;
										color: #555;
									"
									:style="{
										width: this.isMobile ? '3rem' : '4rem',
									}" />
							</p>
							<p
								class="control"
								style="border-left: solid #ccc 1px">
								<a
									@click="incrementQuantity"
									class="button is-medium is-white h2_5-mobile"
									:class="{
										'px-3': !this.isMobile,
										'px-3': this.isMobile,
									}"
									style="color: #777"
									><i class="fas fa-plus"></i>
								</a>
							</p>
						</div>
					</div>
				</div>
				<div
					class="column is-narrow"
					:class="{
						'w60-mobile': isQuantityPickerVisible,
						'w100-mobile': !isQuantityPickerVisible,
					}">
					<button
						@click="addToCart"
						ref="addToCartButton"
						:disabled="this.$data.quantity === 0"
						class="button is-medium is-info is-size-5-mobile w100-mobile">
						<i class="fa-solid fa-cart-shopping"></i>&nbsp;Add to Cart
					</button>
				</div>
				<div class="column is-narrow w100-mobile pt-0-mobile">
					<button
						@click="confirmPurchase"
						:disabled="this.$data.quantity === 0"
						class="button is-medium is-success w100-mobile is-size-4-mobile">
						<i class="fa-solid fa-basket-shopping"></i>&nbsp;Buy Now
					</button>
				</div>
			</div>
		</div>

		<hr class="product-divider" />

		<div class="columns is-multiline p-3 width-100">
			<div class="column has-text-centered-touch m-0 p-0">
				<div class="columns is-size-6 m-0">
					<div
						v-show="model != 'Single-Payment'"
						class="column p-0">
						<span class="mt-3"
							><span class="has-text-weight-bold">Payment Type:</span
							>&nbsp;
							<span
								class="has-text-success"
								v-html="model"></span
						></span>
					</div>
					<div class="column p-0">
						<span class="mt-3"
							><span class="has-text-weight-bold">Delivery:</span>&nbsp;
							<!-- TODO: IF user is logged in allow use of a Primary delivery price e.g Delivery: $600 (calculated using saved delivery method [DELIVERY METHOD NAME]. Change delivery method at checkout if desired. But something shorter than what is said in this todo of course.) -->
							<span class="has-text-success"
								>Calculated at checkout</span
							></span
						>
					</div>
				</div>
			</div>
		</div>

		<quick-purchase
			ref="quickPurchase"
			:endpoint="endpoint"
			:products_prop="[this.productWithSelectedChoices]"
			:terms_and_conditions_link_prop="terms_and_conditions_link_prop"
			:privacy_policy_link_prop="privacy_policy_link_prop"></quick-purchase>
		<purchase-modal
			ref="purchaseModal"
			:endpoint="endpoint"
			:products_prop="[this.productWithSelectedChoices]"
			:sign_up_link_prop="sign_up_link_prop"
			:login_link_prop="login_link_prop"
			:terms_and_conditions_link_prop="terms_and_conditions_link_prop"
			:privacy_policy_link_prop="privacy_policy_link_prop"></purchase-modal>
	</section>
</template>
<style scoped>
	.no-scrollbar::-webkit-scrollbar {
		display: none;
	}

	/* Hide scrollbar for IE, Edge and Firefox */
	.no-scrollbar {
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
	}

	.width-100 {
		width: 100%;
	}

	/* Chrome, Safari, Edge, Opera */
	.quantity-input::-webkit-outer-spin-button,
	.quantity-input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	.quantity-input[type="number"] {
		-moz-appearance: textfield;
	}
</style>
<script type="text/javascript">
	import axios from "axios";
	import Vue from "vue";
	import Buefy from "buefy";
	import PurchaseModal from "../PurchaseInterfaces/PurchaseModal.vue";
	import QuickPurchase from "../PurchaseInterfaces/QuickPurchase.vue";
	import AddToWishlistButton from "../WishlistComponents/AddToWishlistButton.vue";

	Vue.use(Buefy);

	// Setting up input masking should come later
	export default {
		props: [
			"add_to_cart_json_link",
			"model_prop",
			"name_prop",
			"product_id_prop",
			"image_link_prop",
			"sign_up_link_prop",
			"login_link_prop",
			"endpoint",
			"wishlist_link_prop",
			"availability_prop",
			"terms_and_conditions_link_prop",
			"privacy_policy_link_prop",
			"product_prop",
		],
		components: {
			PurchaseModal,
			QuickPurchase,
			AddToWishlistButton,
		},
		data() {
			return {
				wishlist: false,
				quantity: 1,
			};
		},
		computed: {
			model() {
				return this.$props.model_prop;
			},
			name() {
				return this.$props.name_prop;
			},
			product() {
				let product = JSON.parse(this.$props.product_prop);
				if (typeof product?.inventory === "string") {
					product.inventory = JSON.parse(product.inventory);
				}
				return product;
			},
			productWithSelectedChoices() {
				// Accessing the $store state to ensure Vue reactivity when choices change.
				// The actual choices are retrieved via the getter below.
				const reactivityTriggerForChoices = this.$store.state.choices;

				let productWithChoices = {
					...this.product,
					choices: this.$store.getters.choices,
					quantity: this.$store.getters.productQuantity,
				};

				return productWithChoices;
			},
			selectedInventoryItem() {
				const choices = this.productWithSelectedChoices.choices.filter(
					(choice) => choice.choice != "quantity"
				);
				const inventoryItem =
					this.productWithSelectedChoices.inventory.inventory.find(
						(tempInventoryItem) =>
							choices.every(
								(choice) =>
									tempInventoryItem.variant[choice.choice] ==
									choice.value
							)
					);
				return inventoryItem;
			},
			maxInventoryQuantityOfAnyVariant() {
				return Math.max(
					...this.product.inventory.inventory.map((inventoryItem) =>
						parseInt(inventoryItem.quantity)
					)
				);
			},
			selectedInventoryItemQuantity() {
				return parseInt(
					this.selectedInventoryItem?.quantity ??
						this.maxInventoryQuantityOfAnyVariant
				);
			},
			logged_in() {
				return JSON.parse(window.sessionStorage.getItem("logged_in")).value;
			},
			computedQuantity() {
				return parseInt(this.$data.quantity);
			},
			availability() {
				return this.selectedInventoryItemQuantity;
			},
			shouldQuantityPickerBeShown() {
				return this.maxInventoryQuantityOfAnyVariant > 1;
			},
			isQuantityPickerVisible() {
				return this.shouldQuantityPickerBeShown;
			},
			isMobile() {
				return window.screen.width < 768;
			},
		},
		mounted() {
			this.updateQuantity();
		},
		methods: {
			addToWishList() {
				// axios.get()
				//     .then (function(response){})
				//     .catch(function(response){})
				//     .then (function(response){})
				this.wishlist = !this.wishlist;
				// window.notifier.show({
				// 	type: "warning",
				// 	text: `${this.name} Added to WishList`,
				// 	duration: 4000,
				// });
			},
			getUnselectedOptions() {
				let unselectedOptions = [];

				this.$store.getters.choices.forEach((choice) => {
					const isQuantity = choice.choice === "quantity";
					const value = choice.value;
					if (
						(typeof value === "string" && value.trim() === "") ||
						// If it's not product quantity, and the value is falsy, it is unselected
						(!isQuantity && !value)
					) {
						unselectedOptions.push(choice.choice);
					}
				});
				return unselectedOptions;
			},
			areAllOptionsSelected() {
				return !this.getUnselectedOptions().length;
			},
			alertThatOptionIsMissing() {
				const message = `Please select all product options. <br/>The following options have not been selected: ${this.getUnselectedOptions().join(
					", "
				)}`;
				this.$buefy.notification.open({
					message: message,
					type: "is-warning",
					position: "is-top",
					pauseOnHover: true,
					progressBar: true,
					duration: 5000,
					queue: false,
				});
			},
			isProductQuantityZero() {
				return this.$store.getters.productQuantity === 0;
			},

			alertQuantityCannotBeZero() {
				const message = `Product quantity cannot be zero.`;
				this.$buefy.notification.open({
					message: message,
					type: "is-warning",
					position: "is-top",
					pauseOnHover: true,
					progressBar: true,
					duration: 4000,
					queue: false,
				});
			},
			addToCart() {
				if (this.isProductQuantityZero()) {
					return this.alertQuantityCannotBeZero();
				}

				// Prevent user from adding to cart if all options are not selected
				if (!this.areAllOptionsSelected()) {
					return this.alertThatOptionIsMissing();
				}

				let cart = [];
				let _this = this;
				this.$refs.addToCartButton.classList.add("is-loading");
				//If there is something in your cart already then fetch it.
				if (window.localStorage.getItem("cart")) {
					cart = JSON.parse(window.localStorage.getItem("cart"));
				}
				axios
					.get(this.add_to_cart_json_link)
					.then(
						function (response) {
							const fetchedProductData = response.data;
							const product = {
								...fetchedProductData,
								choices: _this.$store.getters.choices,
							};

							cart.push(product);
							this.$buefy.notification.open({
								message: `Successfully added "${product.name}" to Cart!`,
								type: "is-info",
								position: "is-top",
								pauseOnHover: true,
								progressBar: true,
								duration: 4000,
							});
						}.bind(this)
					)
					.catch(function (response) {
						this.$buefy.notification.open({
							message: `Failed to add "${product.name}" to Cart!`,
							type: "is-warning",
							position: "is-top",
							pauseOnHover: true,
							progressBar: true,
							duration: 6000,
						});
					})
					.then(function (response) {
						window.localStorage.setItem("cart", JSON.stringify(cart));
						// Delay for UX, so the loader doesn't flash for the user
						setTimeout(() => {
							_this.$refs.addToCartButton.classList.remove("is-loading");
						}, 400);
					});
			},
			confirmPurchase() {
				// Prevent user from adding to cart if all options are not selected
				if (!this.areAllOptionsSelected()) {
					return this.alertThatOptionIsMissing();
				}

				this.updateQuantity();
				//window.sessionStorage.setItem('logged_in', true | false) is in the main & dash view to tell if a user is logged in or not
				if (JSON.parse(window.sessionStorage.getItem("logged_in")).value) {
					this.$refs.quickPurchase.launchModal();
				} else {
					// This toggles the modal that appears when an unregistered user clicks "Buy Now"
					this.$refs.purchaseModal.launchModal();
				}
			},
			decrementQuantity() {
				if (typeof this.$data.quantity != "number") {
					this.$data.quantity = 1;
				}
				if (this.$data.quantity <= 0) {
					this.$data.quantity = 0;
					return alert(`You cannot go below zero`);
				}
				this.$data.quantity--;
				this.updateQuantity();
			},
			incrementQuantity() {
				if (typeof this.$data.quantity != "number") {
					this.$data.quantity = 1;
				}
				if (this.$data.quantity >= this.availability) {
					this.$data.quantity = this.availability;
					return alert(
						`There are only ${this.availability} of this product available`
					);
				}
				this.$data.quantity++;
				this.updateQuantity();
			},
			updateQuantity() {
				// Parse is needed in case the quantity is read as a text instead of a number, a possible result is NaN.
				const parsedQuantity = parseInt(this.$data.quantity);
				this.$data.quantity = isNaN(parsedQuantity) ? 1 : parsedQuantity;

				// Zero is a valid value for quantity, but elsewhere in the code, do not allow the customer to purchase or add to cart.
				if (this.$data.quantity < 0) {
					this.$data.quantity = 0;
					return;
				}
				if (this.$data.quantity >= this.availability) {
					this.$data.quantity = this.availability;
					return;
				}

				this.$store.dispatch("set_quantity", this.computedQuantity);
			},
		},
		watch: {
			// Watch the product quantity in the store, and if it changes externally, update the local quantity data property to match it. This ensures that if the quantity is changed from somewhere else in the app, this component will reflect that change.
			"$store.state.choices": function (newChoices) {
				if (this.quantity > this.availability) {
					this.quantity = this.availability;
					this.updateQuantity();
				}
				// Consider case where the quantity is zero, but the user changes variant and this product has availability
				// The selected quantity should be set to 1 in this case, as the user is likely trying to purchase the product.
				if (this.quantity == 0 && this.availability) {
					this.quantity = 1;
					this.updateQuantity();
				}
			},
		},
	};
</script>
